/**
 * 网站全局配置
 */

// 网站基础URL，修改此处即可全局生效
export const BASE_URL = 'https://gogamevault.com';

/**
 * 生成规范链接URL
 * @param {string} path - URL路径(不包含域名)
 * @returns {string} 完整的规范链接URL
 */
export function getCanonicalUrl(path = '') {
  // 确保路径以/开头(如果不为空)且不以/结尾
  if (path) {
    path = path.startsWith('/') ? path : `/${path}`;
    path = path.endsWith('/') ? path.slice(0, -1) : path;
  }
  
  return `${BASE_URL}${path}`;
} 